import SlotTableView from "./slot_table_view";
import Module, { moduleInit, bindButtonClickEvent, implementFunction } from "../../../../framework/core/mvvm/module_base";
import SlotTableModel from "./slot_table_model";
import ModuleManager from "../../../../framework/core/module_manager";
import GameMorePanel from "../../../table/module/game_morepanel/game_morepanel";
import SceneManager from "../../../../manager/scene_manager";
import GameServer from "../../../hall/server/gameserver/game_server";
import { NetMsgSlot } from "../../net/net_msg_data_map_slot";
import { SlotRoom } from "../../net/proto/proto_slot_room";
import { SlotGame } from "../../net/proto/proto_slot_game";
import ModelData from "../../../public/model_data";
import SlotRuleModule from "../rule/slot_rule_module";
import { SlotCarryModule } from "../carry/slot_carry_module";
import NetPrompt from "../../../public/module/netprompt/netprompt";
import SlotTableSound from "../table/slot_table_sound"
import AudioManager from "../../../../manager/audio_manager";
import { SlotData } from "./slot_data";
import { joinUtil } from "../../../public/join_util";
import { IUserCurrencyData } from "../../../../manager/user_manager";
import TableBaseModule from "../../../table/module/table_base/table_base_module";
const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit('SlotTableModule')
export default class SlotTableModule extends TableBaseModule<SlotTableView, SlotTableModel> {

    constructor() {
        super();
        this.windowPrefabResPath = "package/slot/slot_table";
        this.viewType = SlotTableView;
        this.modelType = SlotTableModel;
        this.slotRoomData = SlotData.getInstance(true)
    }

    slotRoomData: SlotData
    protected onButtonClickName(name: string) {

        switch (name) {
            case "MoreBtn":
                ModuleManager.instance.showModule(GameMorePanel)
                break
            case "SelfIcon":
                if (this.slotRoomData.cycleStatus == 0) {
                    ModuleManager.instance.showEmojiModule(ModelData.instance.roleData.id, this.moduleName)
                }
                break
            case "New Button Line":
                this.view.testLine()
                break
            case "New Button Kuang":
                this.view.testKuang()
                break
            case "New Button Huifu":
                this.view.testHuifu()
                break
            default:
                break;
        }
    }
    @bindButtonClickEvent("StartBtn", true)
    onbtnStartSpin(node) {
        SlotTableSound.playBtnClickSound(node.name)
        this.startSpin(false)
    }
    @bindButtonClickEvent("StopBtn", true)
    onbtnStopSpin(node) {
        SlotTableSound.playBtnClickSound(node.name)
        this.view.stopDeal()
    }
    @bindButtonClickEvent("AddBtn", true)
    onbtnAdd(node) {
        SlotTableSound.playBtnClickSound(node.name)
        this.slotRoomData.curMultiple = this.slotRoomData.curMultiple == this.slotRoomData.roomRule.maxMultiple ? this.slotRoomData.curMultiple : this.slotRoomData.roomRule.maxMultiple
        this.view.setMultiple(this.slotRoomData.curMultiple)
    }
    @bindButtonClickEvent("ReduceBtn", true)
    onbtnReduce(node) {
        SlotTableSound.playBtnClickSound(node.name)
        this.slotRoomData.curMultiple = this.slotRoomData.curMultiple == this.slotRoomData.roomRule.minMultiple ? this.slotRoomData.curMultiple : this.slotRoomData.roomRule.minMultiple
        this.view.setMultiple(this.slotRoomData.curMultiple)
    }
    @bindButtonClickEvent("InfoBtn", true)
    onbtnInfo(node) {
        SlotTableSound.playBtnClickSound(node.name)
        ModuleManager.instance.showModule<SlotRuleModule>(SlotRuleModule)
    }
    @bindButtonClickEvent("MaxBtn", true)
    onbtnMax(node) {
        SlotTableSound.playBtnClickSound(node.name)
        if (this.slotRoomData.curMultiple == this.slotRoomData.roomRule.maxMultiple) {

        } else {
            this.slotRoomData.curMultiple = this.slotRoomData.roomRule.maxMultiple
            this.view.setMultiple(this.slotRoomData.curMultiple)
        } ModelData.instance
        this.startSpin(false)
    }
    @bindButtonClickEvent("AutoBtn", true)
    onbtnAuto(node) {
        SlotTableSound.playBtnClickSound(node.name)
        this.slotRoomData.autoSpin = !this.slotRoomData.autoSpin
        this.view.setAutoSpin(this.slotRoomData.autoSpin, this.slotRoomData.curMultiple)
        if (this.slotRoomData.autoSpin && this.slotRoomData.cycleStatus == 0) {
            this.startSpin(true)
        }
    }
    @bindButtonClickEvent("AnimMengBan", true)
    animMengban() {
    }
    @bindButtonClickEvent("ContinueBtn", false)
    animContinue() {
        this.view.animContinue()
    }
    @bindButtonClickEvent("CarryBtn", false)
    carryBtn() {
        this.rechargeGold()
    }
    // @implementFunction('onSelfCurrencyDataUpdate')
    // protected onSelfDataUpdate(data: IUserCurrencyData) {
    //     if (!this.slotRoomData.isFirstGameInfo) {
    //         this.model.userCoinBalance()
    //     }
    // }

    onInit() {
        SlotData.roomName = ModelData.instance.tableCommonData.roomRule.minMultiple
        this.slotRoomData.roomRule = ModelData.instance.tableCommonData.roomRule
        this.slotRoomData.curMultiple = this.slotRoomData.roomRule.minMultiple
        this.slotRoomData.payLineCount = this.slotRoomData.roomRule.payLineNumber
    }

    onShow() {
        let self = this;

        SlotTableSound.playSoundEffect(null, function (id) {
            if (self.slotRoomData) {
                self.slotRoomData.effectSoundId = id
            }
        }, true)
        self.view.slotRoomData = self.slotRoomData
        self.view.setMultiple(self.slotRoomData.curMultiple)
        self.eventBind("event_exit_game", function () {
            if (GameServer.instance.netClient.netState) {
                self.model.leave()
            } else {
                SceneManager.gotoHallOrClubHall("TabelExit")
            }
        });
        self.eventBind("start_auto_spin", function (status) {
            self.startSpin(true, status)
        })
        self.eventBind("confirm_carry_gold", function (gold) {
            ModuleManager.instance.showModule(NetPrompt)
            self.model.carry(gold)
        })
        self.eventBind("SetSoundStatus", function (isOpen) {
            if (self.slotRoomData.effectSoundId != undefined || self.slotRoomData.effectSoundId != null) {
                if (isOpen) {
                    SlotTableSound.resumeSound(self.slotRoomData.effectSoundId)
                } else {
                    SlotTableSound.pauseSound(self.slotRoomData.effectSoundId)
                }
            } else {
                if (isOpen) {
                    SlotTableSound.playSoundEffect(null, function (id) {
                        self.slotRoomData.effectSoundId = id
                    }, true)
                }
            }
        })
        self.eventBind("player_coinbalance_changed",function(){
            if (!this.slotRoomData.isFirstGameInfo) {
                this.model.userCoinBalance()
            }
        })
        self.model.init(GameServer.instance.netClient)
        self.model.clearMsgEvent()
        self.registerNetMessage();
    }

    protected registerNetMessage() {
        this.model.subscibeMsgEvent<SlotRoom.IRoomInfo>(NetMsgSlot.RoomInfo, this.roomInfoDeal.bind(this), true);

        this.model.subscibeMsgEvent<SlotRoom.ILeaveBroadcast>(NetMsgSlot.LeaveRoomNotify, this.leaveBroadcast.bind(this), true)

        this.model.subscibeMsgEvent<SlotRoom.ILeaveRsp>(NetMsgSlot.LeaveRoomReq, this.leaveRoomRsp.bind(this), true)

        this.model.subscibeMsgEvent<SlotRoom.ICarryMoneyRsp>(NetMsgSlot.CarryMoneyReq, this.carryMoneyRsp.bind(this), true)

        this.model.subscibeMsgEvent<SlotGame.ISpinRsp>(NetMsgSlot.SpinReq, this.spinRsp.bind(this), true)

        this.model.subscibeMsgEvent<SlotRoom.IUserCoinBalanceNotify>(NetMsgSlot.CoinBalanceNotify, this.coinBalanceUpdate.bind(this), true)
    }

    startSpin(auto: boolean, intent?) {
        if (this.slotRoomData.carryMoney >= this.slotRoomData.payLineCount * this.slotRoomData.curMultiple) {
            ModuleManager.instance.showModule(NetPrompt)
            this.model.spin(this.slotRoomData.curMultiple, auto)
        } else {
            if (auto) {
                this.slotRoomData.autoSpin = false
                this.view.setAutoSpin(this.slotRoomData.autoSpin, this.slotRoomData.curMultiple)
            }
            if (this.slotRoomData.ownMoney > this.slotRoomData.payLineCount * this.slotRoomData.curMultiple + 10) {
                this.rechargeGold()
            } else {
        

                let allowNum = this.slotRoomData.roomRule.pub_AllowNum ? this.slotRoomData.roomRule.pub_AllowNum : 0;                
                if(this.slotRoomData.ownMoney < allowNum){                    
                    //弹充值
                    let goldData = ModelData.instance.tableCommonData.roomRuleData;
                    joinUtil.showRecharge(this,false,goldData);

                }else{

                    if (intent != undefined && intent != null) {
                        this.slotRoomData.autoSpin = false
                        this.view.setAutoSpin(false, this.slotRoomData.curMultiple)
                        if (intent == 0) {
                            this.view.startBaseCycleLine()
                        } else if (intent instanceof Array) {
                            this.view.showBoxLine(intent)
                        }
                    }
                    this.rechargeGold()
                }
            }
        }
    }
    getSeatNodeById(playerId: number): cc.Node {
        if (playerId == ModelData.instance.roleData.id) {
            return this.view.playerPosNode
        }
        return null;
    }
    roomInfoDeal(roomInfo: SlotRoom.IRoomInfo) {
        cc.log("收到roominfo")
        this.slotRoomData.selfPlayer = roomInfo.specPlayer
        this.slotRoomData.carryMoney = roomInfo.specPlayer.walletBalance
        this.slotRoomData.ownMoney = roomInfo.specPlayer.accountBalance + roomInfo.specPlayer.walletBalance
        this.view.updateRoomInfo(this.slotRoomData.carryMoney, this.slotRoomData.ownMoney)

    }

    leaveRoomRsp(proto: SlotRoom.ILeaveRsp) {
        if (proto.errNo == "0") {
            SceneManager.gotoHallOrClubHall("TabelExit")
        }
    }
    coinBalanceUpdate(proto: SlotRoom.IUserCoinBalanceNotify) {
        if (proto.playerId == ModelData.instance.roleData.id) {
            this.slotRoomData.ownMoney = proto.coinBalance    // + this.slotRoomData.carryMoney
            this.view.updateOwnGold(this.slotRoomData.ownMoney)
        }
    }
    leaveBroadcast(proto: SlotRoom.ILeaveBroadcast) {
        if (proto.playerId == ModelData.instance.roleData.id) {
            if (proto.reason == -888) {
                GameServer.instance.netClient.activeClose()
            }
        }
    }

    carryMoneyRsp(proto: SlotRoom.ICarryMoneyRsp) {
        ModuleManager.instance.hideModule("NetPrompt")
        if (proto.code == 0) {
            this.slotRoomData.carryMoney = proto.walletBalance
            this.slotRoomData.ownMoney = proto.accountBalance + proto.walletBalance
            this.view.updatePlayerGold(this.slotRoomData.carryMoney, this.slotRoomData.ownMoney, 1)
        }
    }

    spinRsp(proto: SlotGame.ISpinRsp) {
        ModuleManager.instance.hideModule("NetPrompt")
        if (proto.code == 0) {
            this.view.startAction(proto.result, this.slotRoomData.payLineCount * this.slotRoomData.curMultiple)
            this.eventDispatch('Game_Table_Start');
        } else if (proto.code == -801) {
            this.rechargeGold()
        }
    }

    rechargeGold() {
        ModuleManager.instance.showModule(SlotCarryModule, {
            scene: "game",
            currency: "gold",
            rule: this.slotRoomData.roomRule,
            total: this.slotRoomData.ownMoney
        })
    }


    on_destroy() {
        ModuleManager.instance.destroyModule("SlotCarryModule")
        ModuleManager.instance.destroyModule("SlotRuleModule")
        cc.audioEngine.stopAll()
        AudioManager.instance.resumeMusic()
    }
}
